export const ENTITY = 'OKED';
